module.exports = __webpack_public_path__ + "static/img/rank_88.f1cdd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_88.png
// module id = KLtI
// module chunks = 0